<script>
import { mapState } from 'vuex';
import NonDynamicTransportAllotmentRow from '../../non-dynamic-transport/NonDynamicTransportAllotmentRow';

export default {
  name: 'ItineraryPricesSelectedTransports',
  components: {
    NonDynamicTransportAllotmentRow,
  },
  props: {
    allotments: {
      type: Array,
      required: true,
    },
    maxAllotments: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      headers: [
        this.$t('nonDynamicTransport.headers.fromDate'),
        this.$t('nonDynamicTransport.headers.toDate'),
        this.$t('nonDynamicTransport.headers.releaseDate'),
        this.$t('nonDynamicTransport.headers.releaseDays'),
        this.$t('nonDynamicTransport.headers.issue'),
        this.$t('nonDynamicTransport.headers.notifications'),
        this.$t('nonDynamicTransport.headers.pnr'),
        this.$t('nonDynamicTransport.headers.info'),
        this.$t('nonDynamicTransport.headers.allotment'),
        this.$t('nonDynamicTransport.headers.taxes'),
        this.$t('nonDynamicTransport.headers.yr'),
        this.$t('nonDynamicTransport.headers.netFare'),
        this.$t('nonDynamicTransport.headers.totalFare'),
        '%',
        this.$t('nonDynamicTransport.headers.customerPrice'),
        this.$t('nonDynamicTransport.headers.infant'),
        '%',
        this.$t('nonDynamicTransport.headers.child'),
        '%',
        this.$t('nonDynamicTransport.headers.class'),
        this.$t('nonDynamicTransport.headers.cruise'),
        this.$t('nonDynamicTransport.headers.outbound'),
        this.$t('nonDynamicTransport.headers.inbound'),
      ],
      maxAllotment: null,
      includedOptions: [
        {
          value: 2,
          text: 'Primary',
          hint: 'Use for the primary flight used in price calculations.',
        },
        {
          value: 1,
          text: 'Alternative',
          hint: 'Alternatives to primary flight.',
        },
        {
          value: 0,
          text: 'Optional',
          hint: 'Use for connection flights.',
        },
      ],
    };
  },
  computed: {
    ...mapState({
      transports: state => state.nonDynamicTransport.searchTransports.items,
      transits: state => state.nonDynamicTransport.transits.items,
    }),
  },
  methods: {
    removeAllotmentPeriod(value) {
      const localAllotments = this.allotments.filter(element => element.id !== value.id);
      this.$emit('update', localAllotments);
    },
    setMaxAllotments(value) {
      this.$emit('setMaxAllotment', value);
    },
    validateIncludedOption({ includedOption, allotmentId }) {
      if (includedOption === 2) {
        this.allotments.forEach((allot) => {
          if (allot.included === 2 && allot.id !== allotmentId) {
            allot.included = 1;
          } else if (allot.id === allotmentId) {
            allot.included = 2;
          }
        });
      }
      if (includedOption === 0) {
        this.allotments.forEach((allotment) => {
          if (allotment.id === allotmentId) {
            allotment.included = 0;
          }
        });
      }
    },
  },
};
</script>

<template>
  <div>
    <h2 v-if="allotments.length" class="my-3">Selected transports</h2>
    <v-layout column
      v-for="(allotment, index) in allotments"
      :key="index"
    >
      <div class="table-row">
        <h3 class="xs4">
          <strong>Route: </strong>{{ allotment.transportAllotment.transport.route }}
        </h3>
        <div class="xs8">
          <v-radio-group
            :value="allotment.included"
            @change="validateIncludedOption({includedOption: $event, allotmentId: allotment.id})"
          >
            <v-layout row>
              <div v-for="(included, includedIndex) in includedOptions" :key="includedIndex">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-radio
                      :value="included.value"
                      :label="included.text"
                      hide-details
                      v-on="on"
                    />
                  </template>
                  <span>
                    {{ included.hint }}
                  </span>
                </v-tooltip>
              </div>
            </v-layout>
          </v-radio-group>
        </div>
      </div>
      <table class="selected-allotments-table mb-2">
        <tr>
          <th
            v-for="(header, index) in headers"
            :key="`table-header-${index}`"
            class="table-header"
          >
            {{ header }}
          </th>
        </tr>
        <non-dynamic-transport-allotment-row
          :allotment="allotment.transportAllotment"
          :index="allotment.id"
          read-only
          @remove="removeAllotmentPeriod(allotment)"
        />
      </table>
      <v-flex v-if="allotments.length" xs1>
        <v-text-field
          :value="maxAllotments"
          label="Max. allotments"
          hide-details
          @input="setMaxAllotments"
        />
      </v-flex>
      <v-divider class="mb-2"/>
    </v-layout>
  </div>
</template>

<style scoped lang="scss">
  @import '../../../assets/scss/variables';

  .selected-allotments-table {
    width: 100%;
    font-size: 12px;

    th {
      font-size: $font-size-sm;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/itinerary/itineraryPrices/ItineraryPricesSelectedTransports.vue